import { render, staticRenderFns } from "./SimulationAccount.vue?vue&type=template&id=667f9cf4&scoped=true&"
import script from "./SimulationAccount.vue?vue&type=script&lang=js&"
export * from "./SimulationAccount.vue?vue&type=script&lang=js&"
import style0 from "./SimulationAccount.vue?vue&type=style&index=0&id=667f9cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667f9cf4",
  null
  
)

export default component.exports